import React from 'react';
import { observer ,inject} from 'mobx-react';
import $ from 'jquery';
import { WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

@inject('ganttStore')
@observer
export default class LitterTool extends React.Component<{ganttStore},any>{

    constructor(props){
        super(props);
        this.state={open:false};
    }

    render(){
        const {ganttStore}=this.props;
        const {litterTool}=ganttStore;
        return <div className="litterTool" style={{left:'0px',top:litterTool.top}} onMouseLeave={()=>{
                this.setState({open:false});
                ganttStore.taskOutFun&&ganttStore.taskOutFun();
            }}>
            {litterTool.show&&<div className="litterToolContent">
                {this.state.open? <div className="litterToolList">
                    {litterTool.canRead&&<span title={getLabel('360','打开')} onClick={()=>{
                        this.setState({open:false});
                        ganttStore.openDialog('',litterTool.id);
                    }} className="icon-coms-link litterToolbutton"></span>}
                    {litterTool.canWrite&&<span title={getLabel('501169','编辑')} onClick={()=>{
                       this.setState({open:false});
                       ganttStore.editTaskRow($(`#workSpace_${ganttStore.getGanttId}`).find('tr[data-taskid="'+litterTool.id+'"]'),ganttStore.ganttMaster.getTask(litterTool.id));
                    }} className="icon-coms-edit litterToolbutton"></span>}
                    {litterTool.canDelete&&<span title={getLabel('91','删除')} onClick={()=>{
                        this.setState({open:false});
                        if(litterTool.id.startsWith('tmp')){
                            ganttStore.deleteTmpTaskRow(litterTool.id);
                        }else{
                            ganttStore.currentDeleteId=litterTool.id;
                            ganttStore.deletevisible=true;
                        }
                    }} className="icon-coms-delete litterToolbutton"></span>}
                    {ganttStore.canCreate&&litterTool.canWrite&&ganttStore.isSuperiorFieldSet&&<span title={getLabel('527914','新建上级')} onClick={()=>{
                        this.setState({open:false});
                        ganttStore.addTaskRow(litterTool.id,'above');
                    }} className="icon-coms-Batch-add litterToolbutton"></span>}
                    {ganttStore.canCreate&&<span title={getLabel('527915','新建同级')} onClick={()=>{
                        this.setState({open:false});
                        ganttStore.addTaskRow(litterTool.id,'sibling');
                    }} className="icon-coms-Add-to litterToolbutton"></span>}
                    {ganttStore.canCreate&&ganttStore.isSuperiorFieldSet&&<span title={getLabel('382609','新建下级')} onClick={()=>{
                        this.setState({open:false});
                        ganttStore.addTaskRow(litterTool.id,'below');
                    }} className=" icon-coms-AddTo litterToolbutton"></span>}
                </div>:<div onMouseEnter={()=>{this.setState({open:true})}} className="litterToolMore">
                    <span className="icon-coms-Right"></span>
                </div>}
            </div>}
        </div>
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/gantt/LitterTool.tsx